<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-2">
    <!-- Header -->
    <!-- <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
        <h2 class="text-base/7 font-semibold text-primary">Creators to Screen</h2>
        <p class="text-sm/6 text-secondary">Which creators will you be screening? Select one of the methods below...</p>
    </div> -->
    <!-- Header - END -->

    <!-- Main Content -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        @if (reviewItems.length > 0) {
        <!-- <ul role="list"
            class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 h-full overflow-y-auto scrollbar-transparent pb-2">
            @for (creator of reviewItems; track creator.creatorId) {
            <sbr-creator-review-item [creator]="creator" [briefId]="focussedScreeningBrief.id"></sbr-creator-review-item>
            }
        </ul> -->

        <!-- Include this script tag or install `@tailwindplus/elements` via npm: -->
        <!-- <script src="https://cdn.jsdelivr.net/npm/@tailwindplus/elements@1" type="module"></script> -->
        <ul role="list" class="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2 h-full overflow-y-auto scrollbar-transparent pb-2">
            @for (creator of reviewItems; track creator.creatorId) {
            <sbr-creator-review-item [creator]="creator"
                [briefId]="focussedScreeningBrief.id"></sbr-creator-review-item>
            }
        </ul>


        } @else if (reviewItems.length == 0) {
        <div class="flex flex-col items-center justify-center w-full overflow-hidden">
            <p class="text-sm/6 text-secondary">No creators found</p>
        </div>
        }
        @else {
        <div class="flex flex-col items-center justify-center w-full overflow-hidden">
            <p class="text-sm/6 text-secondary">Laoding</p>
        </div>
        }
    </div>
    <!-- Main Content - END -->
</div>